"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Use-case-neutral variant. NOT sufficient on its own for candidate
 * evaluation: hiring-specific AI laws (NYC Local Law 144, Illinois AI Video
 * Interview Act, Colorado AI Act, EU AI Act) impose notice/audit duties this
 * text does not cover — counsel must confirm scope before hiring use.
 */
const v3 = {
    label: 'I consent to this conversation being **recorded** and **analyzed by AI** ' +
        'to help evaluate my responses. A human reviews the transcript and the ' +
        "AI's assessment. My data may be retained indefinitely unless I " +
        'request deletion.',
    lastUpdated: '2026-06-12',
    modalSections: [
        {
            heading: "What's recorded",
            body: 'Your audio, a transcript of your responses, and basic session ' +
                'data (e.g., timestamps). We do not create a voiceprint or any ' +
                'other biometric identifier from your audio, and we do not use ' +
                'your voice to identify you.',
        },
        {
            heading: 'What the AI does',
            body: 'Analyzes your responses to evaluate them against the criteria for ' +
                'this conversation — including the content of your answers and the ' +
                'information you provide.',
        },
        {
            heading: "What the AI doesn't do",
            body: 'It does not evaluate your appearance, accent, or any protected ' +
                "characteristic. A human reviews the transcript and the AI's " +
                'assessment.',
        },
        {
            heading: 'Your data',
            body: '- Stored encrypted; access limited to the team that invited you.\n' +
                '- May be retained indefinitely unless you request deletion.\n' +
                '- Not sold. Not used to train AI models.',
        },
        {
            heading: 'Your rights',
            body: '- **Decline** this format and request to speak with a person instead — this will not affect your standing.\n' +
                '- **Access or delete** your recording and assessment at any time.\n' +
                '- **Request human review** of any decision you believe was unfair.\n' +
                '- Residents of certain states (including California) and other ' +
                'jurisdictions (such as the EU and UK) may have additional rights ' +
                'under applicable privacy laws.',
        },
        {
            heading: 'Questions or concerns',
            body: 'Contact the team at the email provided in your invitation.',
        },
    ],
};
exports.default = v3;
